<template>
    <div>
      <!-- Body -->
      <div class="body">
        <div>
          <themed-table
            :headers="this.transformedHeaders"
            :data="transformedData"
            :pagination="{
                perPage: this.bedManagerService.devices.query.limit,
              total: this.bedManagerService.devices.total,
              page: Math.floor(this.bedManagerService.devices.query.skip / this.bedManagerService.devices.query.limit) + 1
            }"
            :version="version"
            :sortingEnabled=true
            :filteringEnabled=false
            :paginationEnabled="this.bedManagerService.devices.total > this.bedManagerService.devices.query.limit"
            :tenantSelected=currentTenant
            :tenantOptions=this.bedManagerService.tenants.data
            :locationTreeSearchValue="this.bedManagerService.devices.searchValue"
            @paginationChange="(event) => {
              this.bedManagerService.devices.query.skip = this.bedManagerService.devices.query.limit * (event.page - 1);
              this.bedManagerService.devices.query = {...this.bedManagerService.devices.query};
            }"
            @areasChange="(event) => {
                this.bedManagerService.devices.searchValue = '';
                this.bedManagerService.devices.query.area = event;
                this.bedManagerService.devices.query = {...this.bedManagerService.devices.query};
                const item = this.bedManagerService.devices.headers.find((header) => header.key === 'poc');
                if (item && event && event.length) {
                  item.filterActive = true;
                } else if (item) item.filterActive = false;
                this.bedManagerService.devices.headers = [...this.bedManagerService.devices.headers];
            }"
            @locationTreeSearch="(event) => {
                this.bedManagerService.devices.searchValue = event;
            }"
            @searchChange="(event) => {
              const query = this.bedManagerService.devices.query;
              query.skip = 0; // Resets skip as the search params change
              let newTenant = null;
              Object.keys(event).forEach((key) => {
                const customHandlers = ['scope', 'deviceCount'];
                  if (!customHandlers.includes(key) && event[key]) query[key] = typeof event[key] === 'string' ? event[key].trim() : event[key];
                  else if (key === 'scope' && event[key] && this.bedManagerService.tenants.selected !== event[key]) newTenant = event[key];
                  else if (key === 'deviceCount' && event[key]) query['deviceId'] = typeof event[key] === 'string' ? event[key].trim() : event[key];
                  else delete query[key];
              })
              if (newTenant !== null) {
                Object.keys(query).forEach((prop) => this.bedManagerService.devices.query[prop] = query[prop]);
                this.bedManagerService.tenants.selected = newTenant;
                if (!newTenant) {
                  this.bedManagerService.devices.data = [];
                  this.bedManagerService.devices.total = 0;
                  this.bedManagerService.jobs.data = [];
                  this.bedManagerService.jobs.total = 0;
                }
              } else {
                this.bedManagerService.devices.query = {...query};
              }
            }"
            @tenantChange="(event) => {
              this.bedManagerService.tenants.selected = event;
              this.bedManagerService.fetchCreateJobsDevices(event)
              if (!event) {
                this.bedManagerService.devices.data = [];
                this.bedManagerService.devices.total = 0;
                this.bedManagerService.jobs.data = [];
                this.bedManagerService.jobs.total = 0;
              }
            }"
            @sortingChange="(event) => {
              if (event.type === 'firmwareVersionFormatted') {
                this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: 'firmwareVersion', sortDirection: event.direction };
              } else if (event.type === 'status') {
                this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: 'isOffline', sortDirection: event.direction };
              } else if (event.type === 'serial') {
                this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: 'properties.bedData.PropertiesResponse.GatewayMACAddress', sortDirection: event.direction };
              } else if (event.type === 'lastSeen') {
                this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: 'lastHealthReported', sortDirection: event.direction };
              } else if (event.type === 'provisionedOn') {
                this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: 'registeredOn', sortDirection: event.direction };
              } else {
                this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query, sortProperty: event.type, sortDirection: event.direction };
              }
            }"
            @rowClick="(item, event) => {
              if (event && event.target.textContent.includes('See versions')) return;
              setDevice(item);
            }"
            :addItem="{ label: 'Job', element: CreateJobs }"
            :refreshEnabled="true"
            @refresh="bedManagerService.fetchDevices()"
            :downloadEnabled="true"
            :downloading="isExportingDeviceIds"
            downloadTooltip="Download devices (CSV)"
            @download="downloadDevicesCsv"
            ></themed-table>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Vue from "vue";
  import VueToast from "vue-toast-notification";
  import Loading from "vue-loading-overlay";
  import "vue-loading-overlay/dist/vue-loading.css";
  import ThemedTable from "../../../shared/careai/components/ThemedTable.vue";
  import BedManagerService from "../BedManager.service";
  import CreateJobs from "../jobs/CreateJobs.vue";
import { event } from "jquery";
  import { exportToCsv } from "../../../shared/utils/csv";

  const moment = require("moment");

  Vue.use(VueToast);
  Vue.use(Loading);
  Vue.component('themed-table', ThemedTable);

  export default {
    name: "DeviceAttributes",
    components: { },
    data() {
      return {
        console: console,
        moment: moment,
        CreateJobs: CreateJobs,

        // Singleton Pattern Service
        // Contains State and API Requests
        bedManagerService: BedManagerService,

        isExportingDeviceIds: false,
      };
    },
    computed: {
      version() {
      return this.bedManagerService ? this.bedManagerService.appVersion : '0.0.0';
      },
      transformedHeaders() {
        return this.bedManagerService.devices.headers;
      },
      transformedData() {
        return this.bedManagerService.devices.data.map((item) => {
          item.locationId = item.location;
          item.unitId = item.unit;
          item.areaId = item.area;
          item.serial = item.properties && item.properties.bedData && item.properties.bedData.PropertiesResponse && item.properties.bedData.PropertiesResponse.GatewayMACAddress;
          item.lastSeen = item.lastHealthReported ? moment(item.lastHealthReported).format("MMMM Do, YYYY [at] h:mm A") : '';
          item.provisionedOn = item.registeredOn ? moment(item.registeredOn).format("MMMM Do, YYYY [at] h:mm A") : '';
          if(item.properties && item.properties.bedData && item.properties.bedData.PropertiesResponse && item.properties.bedData.PropertiesResponse){
            item.configurationsFormatted = ""
            Object.entries(item.properties.bedData.PropertiesResponse).forEach(([key, value]) => {
              item.configurationsFormatted += `<div style="text-wrap: wrap;"><b>${this.capitalizeFirstLetter(key)}</b>: ${value}</div>`;
            });
            item.configurationsFormatted = `<div style="display: flex; flex-direction: column;">${item.configurationsFormatted}</div>`;
          }
          const versionInfo = item.properties && item.properties.version;
          const gwVersion = versionInfo && versionInfo.GatewaySWVersionNumber;
          const otherVersionEntries = versionInfo
            ? Object.entries(versionInfo).filter(([key]) => key !== 'GatewaySWVersionNumber')
            : [];
          const otherVersionsTooltip = otherVersionEntries
            .map(([key, value]) => `${key}: ${value}`)
            .join('\n');
          item.firmwareVersionFormatted = `<div style="display: flex; flex-direction: column; margin-left:13px">
            ${versionInfo
              ? `<div>GW: ${gwVersion || 'N/A'}</div>`
              : "No version info"}
            ${otherVersionEntries.length
              ? `<div class="see-version" title="${otherVersionsTooltip.replace(/"/g, '&quot;')}">See versions</div>`
              : ""}
          </div>`;


          if (item.deviceId) {
            item.status = `<div data-toggle="tooltip" title="Device ${item.isOffline ? 'offline' : 'online'}." class="${item.isOffline ? 'isNotReady' : 'isReady'}"></div>`;
          }
          item.location = item.locationName || '';
          item.unit = item.unitName || '';
          item.area = item.areaName || '';
          item.poc = `${item.areaName ? `${item.areaName} / ` : ''}${item.unitName ? `${item.unitName} / ` : ''} ${item.locationName || ''}`;

          return item;
        });
      },
      currentDMConfiguration() {
        if (this.bedManagerService.configuration) {
            return this.bedManagerService.configuration;
        }
        return null;
      },
      currentQuery() {
        if (this.bedManagerService.devices.query) {
            return this.bedManagerService.devices.query;
        }
        return null;
      },
      currentTenant() {
        if (this.bedManagerService.tenants) {
            return this.bedManagerService.tenants.selected;
        }
        return null;
      },
      currentConfiguration() {
        if (this.currentDMConfiguration && this.currentDMConfiguration.tasks) {
            return this.currentDMConfiguration.tasks;
        }
        return null;
      },
    },
    watch: {
        currentQuery(newQuery, oldQuery) {
          this.bedManagerService.fetchDevices();
        },
        currentTenant() {
          this.bedManagerService.fetchDevices();
        },
        currentConfiguration() {
          this.bedManagerService.devices.query = { ...this.bedManagerService.devices.query };
        }
    },
    mounted() {
      if (!this.bedManagerService.devices.data.length) this.bedManagerService.fetchDevices();
    },
    unmounted() {},
    methods: {
      capitalizeFirstLetter(str) {
        if (!str) return str;
        return str.charAt(0).toUpperCase() + str.slice(1);
      },
      setDevice(event) {
        // remember current tab so we can restore it when closing device attributes
        this.bedManagerService.previousTabIndex = this.bedManagerService.tabIndex;
        this.bedManagerService.selectedDevice = { ...this.bedManagerService.selectedDevice, id: null, data: [] };
        setTimeout(() => {
          this.bedManagerService.selectedDevice = { ...this.bedManagerService.selectedDevice, id: event.deviceId, data: []};

          setTimeout(() => this.bedManagerService.tabIndex = 2, 15);
          if (this.bedManagerService.selectedJob.data.length) {
            setTimeout(() => this.bedManagerService.tabIndex = 4, 25);
          } else setTimeout(() => this.bedManagerService.tabIndex = 3, 25);
        }, 1000)
      },
      deviceExportColumns() {
        return [
          { key: 'status', label: 'Status' },
          { key: 'tenant', label: 'Tenant' },
          { key: 'deviceId', label: 'Device ID' },
          { key: 'serial', label: 'MAC' },
          { key: 'versions', label: 'Version(s)' },
          { key: 'poc', label: 'Location' },
          { key: 'lastSeen', label: 'Last Seen' },
          { key: 'provisionedOn', label: 'Provisioned On' },
        ];
      },
      // Plain-text row matching the columns shown in the table. The grid renders some of
      // these as HTML, so the CSV uses the underlying values instead.
      toDeviceExportRow(item) {
        const bedProperties = item.properties && item.properties.bedData && item.properties.bedData.PropertiesResponse;
        const versionInfo = item.properties && item.properties.version;
        const otherVersions = versionInfo
          ? Object.entries(versionInfo)
            .filter(([key]) => key !== 'GatewaySWVersionNumber')
            .map(([key, value]) => `${key}: ${value}`)
          : [];
        const versions = versionInfo
          ? [`GW: ${versionInfo.GatewaySWVersionNumber || 'N/A'}`, ...otherVersions].join('; ')
          : '';
        const formatTimestamp = (value) => (value ? moment(value).format('MMMM Do, YYYY [at] h:mm A') : '');

        return {
          status: item.deviceId ? (item.isOffline ? 'Offline' : 'Online') : '',
          tenant: item.tenant || '',
          deviceId: item.deviceId || '',
          serial: (bedProperties && bedProperties.GatewayMACAddress) || '',
          versions,
          poc: `${item.areaName ? `${item.areaName} / ` : ''}${item.unitName ? `${item.unitName} / ` : ''}${item.locationName || ''}`.trim(),
          lastSeen: formatTimestamp(item.lastHealthReported),
          provisionedOn: formatTimestamp(item.registeredOn),
        };
      },
      async downloadDevicesCsv() {
        if (this.isExportingDeviceIds) return; // Already fetching - ignore repeat clicks.
        this.isExportingDeviceIds = true;
        try {
          // Pulls every device matching the current filters, not just the currently loaded page.
          const allDevices = await this.bedManagerService.fetchAllDevicesForExport();
          const rows = allDevices.map((item) => this.toDeviceExportRow(item));
          if (!rows.length) {
            Vue.$toast.open({ message: 'No devices available to download.', type: 'info' });
            return;
          }
          const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
          exportToCsv(rows, this.deviceExportColumns(), `devices_${timestamp}.csv`);
        } catch (e) {
          this.console.error(e);
          Vue.$toast.open({ message: 'Failed to download devices due to an error.', type: 'error' });
        } finally {
          this.isExportingDeviceIds = false;
        }
      },
      filterJson(data, search) {
        const lowerSearch = search.toLowerCase();
        if (Array.isArray(data)) {
            const filteredArray = data
            .map(item => this.filterJson(item, search))
            .filter(item =>
                item !== undefined &&
                (typeof item !== 'object' ||
                (Array.isArray(item) ? item.length : Object.keys(item).length))
            );
            return filteredArray.length ? filteredArray : undefined;
        } else if (data && typeof data === 'object') {
            const result = {};
            for (const key in data) {
                if (!data.hasOwnProperty(key)) continue;
                const value = data[key];
                const keyMatches = key.toLowerCase().includes(lowerSearch);
                if (keyMatches) {
                    result[key] = value;
                } else if (value !== null && typeof value === 'object') {
                    const filteredValue = this.filterJson(value, search);
                    if (
                    filteredValue !== undefined &&
                    (Array.isArray(filteredValue)
                        ? filteredValue.length
                        : Object.keys(filteredValue).length)
                    ) {
                        result[key] = filteredValue;
                    }
                } else {
                    const strValue = String(value).toLowerCase();
                    if (strValue.includes(lowerSearch)) {
                        result[key] = value;
                    }
                }
            }
            return Object.keys(result).length ? result : undefined;
        } else {
            return String(data).toLowerCase().includes(lowerSearch) ? data : undefined;
        }
      }
    },
  };
  </script>

  <!-- Header Styles -->
  <style lang="scss" scoped>
    .page-header {
      &__flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      &__statistics {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      &__statistics-item {
        font-size: .7em;
        display: flex;
        flex-direction: column;
      }
    }

    .body {
        &__inner {
            padding: 15px;
        }
    }

  </style>

  <style>
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .see-version {
    color: #1dd8f6;
    cursor: pointer;
    font-size: 1.1em;
  }
  </style>
